<template>
  <el-dialog :before-close="handleOnClose" title="Edit Criticality for the Selected Host(s)"
             :visible.sync="openCriticalityDialogVisible">
    <el-form :model="criticalityForm">
      <label class="body1">Select the criticality level</label>
      <el-form-item>
        <el-radio-group v-model="criticalityForm.criticality">
          <el-radio class="display-block" :label="criticalityOptions.CRITICAL">
            <i class="display-inline-block icon icon-criticality-critical"/> {{ criticalityOptions.CRITICAL }}
          </el-radio>
          <el-radio class="display-block" :label="criticalityOptions.IMPORTANT">
            <i class="display-inline-block icon icon-criticality-important"/> {{ criticalityOptions.IMPORTANT }}
          </el-radio>
          <el-radio class="display-block" :label="criticalityOptions.REGULAR">
            <i class="display-inline-block icon icon-criticality-regular"/> {{ criticalityOptions.REGULAR }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <p class="body1">This change will be reflected across the application and your organization.</p>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleOnClose">Cancel</el-button>
      <el-button type="primary"
                 @click="setCriticalityLevel(selectedRows, criticalityForm.criticality)">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {CriticalityEnum, CriticalityLevelEnum} from "../../constants/criticality.constants";
import {BULK_HOSTNAME_REQ, CUSTOM_HOSTNAME_REQ} from "../../store/modules/agents/agents.type";

export default {
  name: "EditCriticalityDialog",
  props: {
    agent: {},
    openCriticalityDialogVisible: {
      default() {
        return false;
      },
      type: Boolean
    },
    onClose: {
      default() {
        return undefined;
      },
      type: [Function]
    },
    onSubmit: {
      default() {
        return undefined;
      },
      type: [Function]
    }
  },
  computed: {
    criticalityOptions() {
      return CriticalityLevelEnum;
    },
    criticalityLevel() {
      return this.agent && CriticalityEnum.properties[this.agent.criticality.toLowerCase()].title
    }
  },
  data() {
    return {
      criticalityForm: {criticality: ""},
      selectedRows: []
    };
  },
  methods: {
    handleOnClose() {
      this.criticalityForm.criticality = this.criticalityLevel
      this.onClose()
    },
    setCriticalityLevel(rows, criticality) {
      const payload = {
        agentId: this.agent.agentDetails.agentId,
        customHostname: this.agent.agentDetails.hostname,
        criticality: criticality
      };

      const message = `All hosts have been marked ${criticality}`;

      const handleError = (error) => {
        this.$message({
          type: "error",
          message: error || "Something went wrong."
        });
        this.openCriticalityDialogVisible = true;
      };

      if (this.agent) {
        this.$store.dispatch(CUSTOM_HOSTNAME_REQ, payload).then(
            () => {
              this.onSubmit()
              this.openCriticalityDialogVisible = false;
              this.$message({
                type: "success",
                message: `Host has been marked ${criticality}`
              });
            },
            handleError
        );
      } else {
        for (const row of rows) {
          row.criticality = criticality;
        }

        this.$store.dispatch(BULK_HOSTNAME_REQ, rows).then(
            () => {
              this.openCriticalityDialogVisible = false;
              this.$message({
                type: "success",
                message
              });
            },
            handleError
        );
      }
    }
  },
  watch: {
    agent: {
      deep: true,
      immediate: true,
      handler(newAgent) {
        if (newAgent.criticality) {
          this.criticalityForm.criticality = this.criticalityLevel;
        }
      }
    }
  }
};
</script>

<style scoped>
>>> .el-dialog {
  height: fit-content;
  min-height: 200px;
  width: 80%;
  max-width: 960px;
}

.icon {
  font-size: 14px;
  font-style: italic;
  font-weight: 700;
}

.body1 {
  font-size: 14px;
  font-style: italic;
  font-weight: 700;
}

>>> .el-dialog__header {
  padding: 20px 28px 10px;
}

>>> .el-dialog__title {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
}

>>> .el-form-item {
  margin-top: 12px;

  .el-radio__label {
    font-weight: 700;
  }
}

.display-block {
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/EditCriticalityDialog.vue